import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { Mark } from "@mashriqain/ui";
import { site } from "@/content/site";
import { INTRO_SECONDS, introPlays } from "@/lib/intro";
import styles from "./Intro.module.css";

const EASE = [0.76, 0, 0.24, 1] as const;

/**
 * The first moment of a visit: the mark is drawn in ink line by line, the
 * Arabic name settles beneath it, and the porcelain parts like two doors.
 * Plays once per session and never with reduced motion.
 */
export function Intro() {
  const [open, setOpen] = useState(introPlays);

  useEffect(() => {
    if (!open) return;
    const root = document.documentElement;
    root.style.overflow = "hidden";
    const t = window.setTimeout(() => setOpen(false), INTRO_SECONDS * 1000);
    return () => {
      window.clearTimeout(t);
      root.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className={styles.intro} aria-hidden="true" exit={{ pointerEvents: "none" }}>
          <motion.div
            className={`${styles.door} ${styles.top}`}
            exit={{ y: "-100%", transition: { duration: 1.1, ease: EASE } }}
          />
          <motion.div
            className={`${styles.door} ${styles.bottom}`}
            exit={{ y: "100%", transition: { duration: 1.1, ease: EASE } }}
          />
          <motion.div
            className={styles.center}
            exit={{ opacity: 0, scale: 0.96, transition: { duration: 0.5 } }}
          >
            <Mark size={92} draw className={styles.mark} />
            <motion.p
              className={`ar ${styles.arabic}`}
              lang="ar"
              dir="rtl"
              initial={{ opacity: 0, y: 10, filter: "blur(6px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 1.2, delay: 1.1 }}
            >
              {site.arabicName}
            </motion.p>
            <motion.span
              className={styles.line}
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: INTRO_SECONDS - 0.4, ease: [0.65, 0, 0.35, 1] }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
